import { constants } from '@tradetrust-tt/token-registry-v4';

const roleHash = constants.roleHash;

export { roleHash };
